import { Chat } from '@carbon/react/icons';
import classNames from 'classnames';
import { IconProps } from './types';

import style from './icons.module.scss';

const Comment = ({ className }: IconProps) => {
  return (
    <div className={classNames(style.background, style.comment, className)}>
      <Chat size={32} className={classNames(style.icon, style.comment)} />
    </div>
  );
};

export default Comment;
